<app-breadcrumb [master]="'Struktura sieci'" [parentName]="'Partnerzy'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group (selectedTabChange)="onTabChange($event)" [(selectedIndex)]="selectedTab">
  <mat-tab label="Dane">
    <app-partner-details-view *ngIf="!modify" (modifyClicked)="modify = true" [partner]="partner" (partnerChanged)="loadPartner()"></app-partner-details-view>
    <app-add *ngIf="modify" (closeModification)="modify = false; loadPartner()" [partner]="partner" [disableBreadcrumbs]="true" (disableContract)="disableContract($event)"></app-add>
  </mat-tab>
  <mat-tab label="Placówki">
    <ng-template matTabContent>
      <app-facilities-list [partner]="partner" (changed)="loadPartner()"></app-facilities-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="OFWCA">
    <ng-template matTabContent>
      <div fxLayout="column">
        <div fxLayout="row">
          <button [disabled]="!(userPermissions | async).ofwca.write" mat-stroked-button color="primary" class="add-button" (click)="addOfwca()"><mat-icon>add</mat-icon> Dodaj OFWCA</button>
        </div>

        <div fxLayout="row">
          <mat-form-field appearance="standard" class="view-select">
            <mat-label>Widok</mat-label>
            <mat-select [formControl]="ofwcaViewControl">
              <mat-option [value]="ACTIVE_VIEW">Aktywne</mat-option>
              <mat-option [value]="ARCHIVE_VIEW">Archiwum</mat-option>
              <mat-option [value]="REGISTRATIONS_VIEW">Wszystkie</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <app-ofwcas-list
          *ngIf="ofwcaViewControl.value !== REGISTRATIONS_VIEW"
          [excludeColumns]="['partner', 'phone']"
          [ofwcas]="ofwcas" (changed)="loadOfwcas()"
        ></app-ofwcas-list>
        <app-ofwcas-list
          *ngIf="ofwcaViewControl.value === REGISTRATIONS_VIEW"
          [excludeColumns]="['partner']"
          [ofwcas]="ofwcas" [partnerObject]="partnerObject" (changed)="loadOfwcas()"
        ></app-ofwcas-list>
      </div>
    </ng-template>
  </mat-tab>
  <mat-tab label="Umowy"  [disabled]="ofwcaPartnerOff" >
    <ng-template matTabContent>
      <button [disabled]="!(userPermissions | async).contract.create" mat-stroked-button color="primary" class="add-button" (click)="addContract()"><mat-icon>add</mat-icon> Dodaj umowę</button>
      <app-contract-list [excludeColumns]="[]" [contracts]="contracts" (contractDeleted)="loadContracts()"></app-contract-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Dokumenty">
    <ng-template matTabContent>
      <button [disabled]="!(userPermissions | async).document.write" mat-stroked-button color="primary" class="add-button" (click)="addDocument()"><mat-icon>add</mat-icon> Dodaj dokument</button>

      <app-document-list [excludeColumns]="['partnerOrOfwca', 'deviceProtocolDdate']" [documents]="documents" (changed)="loadDocuments()"></app-document-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Partnerzy Nadrzędni" *ngIf="partnerObject && partnerObject.hasChildPartners">
    <ng-template matTabContent>
      <app-child-partners-list [partner]="partner"></app-child-partners-list>
    </ng-template>
  </mat-tab>
  <mat-tab label=" Partnerzy Nadprowizja" *ngIf="partnerObject && partnerObject.hasChildOvercommissionPartners">
    <ng-template matTabContent>
      <app-child-partners-list [partner]="partner" [overcommission]="true"></app-child-partners-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Notatki" *ngIf="(userPermissions | async).note.limited_read">
    <ng-template matTabContent>
      <button [disabled]="!(userPermissions | async).note.limited_read" mat-stroked-button color="primary" class="add-button" (click)="addNote()"><mat-icon>add</mat-icon> Dodaj notatkę</button>
      <app-note-list [notes]="notes" (changed)="loadNotes()"></app-note-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Agent21" *ngIf="(userPermissions | async).licensed_agent.read" >
    <ng-template matTabContent>
      <button [disabled]="!(userPermissions | async).licensed_agent.read" mat-stroked-button color="primary" class="add-button" (click)="addAgent21()"><mat-icon>add</mat-icon> Dodaj licencję</button>
      <app-all-agent-21
        [showFilter]="false" [partnerId]="partnerId"  [embeddedView]="true">
      </app-all-agent-21>
    </ng-template>
  </mat-tab>
  <mat-tab label="Linki afiliacyjne"  >
    <ng-template matTabContent>
      <button [disabled]="!(userPermissions | async).partner.admin_root" mat-stroked-button color="primary" class="add-button" (click)="addAffiliateCod()"><mat-icon>add</mat-icon> Wygeneruj kod</button>
      <app-affiliate-code-list
        [affiliateCodes]="affiliateCode"
        (loadAffiliate)="loadAffiliateCode()"
        [excludeColumns]="['insuranceCompany', 'partner', 'affiliateLink']"
      ></app-affiliate-code-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [partner]="partner"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
